import type { LayoutLoad } from './$types';
import survey from '../content/survey.yaml';
import { interpretSurvey } from '$lib/utils/surveyInterpreter';

export const trailingSlash = 'always';

export const load: LayoutLoad = async ({ url, route }) => {
  // Process the survey YAML once for both SSR and CSR
  const processedSurvey = interpretSurvey(survey, url.origin);
  if (!processedSurvey) throw new Error('Survey processing failed');

  let ogConfig = null;

  // Route: / (root) - use survey config.og
  if (route.id === '/' || route.id === null) {
    if (!processedSurvey.config?.og) {
      throw new Error('Survey config.og is required');
    }

    ogConfig = processedSurvey.config.og;
  }
  // Route: /profile/xxx - use profile header with survey fallback
  else if (route.id?.includes('/profile/')) {
    // Only process on SSR for static generation
    if (import.meta.env.SSR) {
      const pathSegments = url.pathname.split('/').filter(Boolean);
      const profileId = pathSegments[1];

      if (!profileId || !processedSurvey.profiles) {
        throw new Error('Profile route requires profile data');
      }

      const profile = processedSurvey.profiles.find((p: any) => p.id === profileId);
      if (!profile) {
        throw new Error(`Profile ${profileId} not found`);
      }

      // Use profile OG if available, otherwise fall back to header
      const ogImage = profile.header?.image || processedSurvey.config.og?.image;

      ogConfig = {
        title: profile.header?.title || processedSurvey.config.og?.title,
        description: profile.header?.subtitle || processedSurvey.config.og?.description,
        image: ogImage
      };

      if (!ogConfig.title || !ogConfig.description || !ogConfig.image) {
        throw new Error('Profile OG requires title, description, and image');
      }
    }
  }
  // Route: /stats or /s/xxx - use survey OG as fallback
  else if (route.id?.includes('/stats') || route.id?.includes('/s/')) {
    if (processedSurvey.config?.og) {
      ogConfig = processedSurvey.config.og;
    }
  }

  return {
    survey: processedSurvey,
    og: ogConfig
  };
};
